import { render, staticRenderFns } from "./clinicsEdit.vue?vue&type=template&id=bc35bd56&"
import script from "./clinicsEdit.vue?vue&type=script&lang=js&"
export * from "./clinicsEdit.vue?vue&type=script&lang=js&"
import style0 from "./clinicsEdit.vue?vue&type=style&index=0&id=bc35bd56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports